const styles = () => ({
    container: {
        textAlign: 'center',
        display: 'inline-block',
        '-webkit-border-radius': '100px 100px 0 100px',
        borderRadius: '100px 100px 0 100px',
        background: '#246AA7',
        padding: '4px',
        margin: '4px',
        width: '28px',
        color: 'white',
        '&:hover': {
            color: '#fff',
            fontWeight: 500,
            backgroundColor: '#A40943',
        },
    },
    active: {
        color: '#fff',
        fontWeight: 500,
        backgroundColor: '#A40943',
    },
    disable: {
        fontWeight: 500,
        backgroundColor: '#ccc',
    },
    text: {
        padding: 0,
    },
});

export default styles;
